import UserChangePassword from 'components/admin/Users/UserChangePassword'
import {
  FormCheckbox,
  FormDropdown,
  FormInput,
  FormRadio,
  validateEmail,
  validateRequired,
} from 'components/shared/Forms/ReduxForm'
import Loader from 'components/shared/Helpers/Loader'
import config from 'config/config'
import placeholder from 'images/placeholder.png'
import placeholder_inverted from 'images/placeholder_inverted.png'
import { I18n } from 'lib/i18n'
import React from 'react'
import Dropzone from 'react-dropzone'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, formValues, registerField } from 'redux-form'
import { clearCreatedMedia, createMedium } from 'redux/media'
import { Button, Divider, Form, Grid, Header, Icon, Image } from 'semantic-ui-react'

const i18nkey = 'admin.user.'

const mapStateToProps = (state, ownProps) => {
  const {
    loadingMedia,
    uploadingMedia,
    singleDropzoneUpload,
    createdMedia,
    media,
  } = state.media
  return {
    loadingMedia,
    uploadingMedia,
    singleDropzoneUpload,
    createdMedia,
    media,
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      registerField,
      createMedium,
      clearCreatedMedia,
    },
    dispatch
  )
}

class UserCoreData extends React.Component {
  state = {}
  componentWillReceiveProps(nextProps) {
    const {
      change,
      createdMedia: createdMediaOld,
      clearCreatedMedia,
    } = this.props
    const {
      createdMedia: createdMediaNew,
      singleDropzoneUpload: singleDropzoneUploadNew,
    } = nextProps
    const { uploading } = this.state
    if (!createdMediaOld && createdMediaNew && singleDropzoneUploadNew && uploading) {
      change('logo_asset_id', createdMediaNew[0].id)
      clearCreatedMedia()
      this.setState({uploading: false})
    }
  }

  render() {
    const dark = config.theme.dark
    const {
      user,
      change,
      isWinDeltaDealer, //ownProps
      address_number,
      media = [],
      logo_asset_id, //formValues
      createMedium,
      loadingMedia,
      uploadingMedia, //connect
    } = this.props //redux

    let logoSrc = dark ? placeholder_inverted : placeholder

    if (logo_asset_id) {
      const image = media.find((asset) => asset.id === logo_asset_id)
      if (image) {
        logoSrc = config.api_url + image.large_url
      }
    }
    const dealerLogo =
      loadingMedia || uploadingMedia ? <Loader /> : <Image src={logoSrc} />

    return (
      <Grid>
        <Grid.Row columns={3}>
          <Grid.Column width={12}>
            <Grid stackable>
              <Grid.Row>
                <Grid.Column width={4}>
                  <Header as="h3" dividing content="Status" />
                  <Form.Group>
                    <Field
                      component={FormRadio}
                      label={I18n.t(i18nkey + 'status.active')}
                      option="active"
                      name="status"
                    />
                    <Field
                      component={FormRadio}
                      label={I18n.t(i18nkey + 'status.inactive')}
                      option="inactive"
                      name="status"
                    />
                    <Field
                      component={FormRadio}
                      label={I18n.t(i18nkey + 'status.archived')}
                      option="archived"
                      name="status"
                      className={config.semantic_ui.primary_color}
                    />
                  </Form.Group>
                </Grid.Column>

                {!isWinDeltaDealer ? (
                  <Grid.Column width={4}>
                    <Header as="h3" dividing content="Benutzertyp" />
                    <Form.Group>
                      <Field
                        component={FormRadio}
                        label={I18n.t(i18nkey + 'type.admin')}
                        option="admin"
                        name="user_type"
                      />
                      <Field
                        component={FormRadio}
                        label={I18n.t(i18nkey + 'type.user')}
                        option="user"
                        name="user_type"
                      />
                    </Form.Group>
                  </Grid.Column>
                ) : (
                  <Grid.Column width={4}>
                    <Header as="h3" dividing content="Kundennummer" />
                    <Header as="h4" content={address_number} />
                  </Grid.Column>
                )}

                <Grid.Column width={4}>
                  <Header as="h3" dividing content={I18n.t(i18nkey + 'logo')} />
                  {logo_asset_id && (
                    <Dropzone
                      onDrop={(accepted) => {
                        this.setState({uploading: true})
                        createMedium(accepted, true)
                        change('logo_asset_id', null)
                      }}
                      style={{}}
                      activeClassName="valid"
                      className="dropZone area"
                      children={dealerLogo}
                    />
                  )}

                  <div className="buttonwrapper">
                    {logo_asset_id && user.user_type !== 'bop' && (
                      <Button
                        color="red"
                        secondary={dark}
                        size="tiny"
                        icon="trash"
                        content={I18n.t('admin.mediaBrowser.delete')}
                        onClick={() => change('logo_asset_id', null)}
                      />
                    )}
                    {logo_asset_id && (
                      <a
                        className="ui tiny button"
                        role="button"
                        href={logoSrc}
                        download
                      ><Icon name="download"/>{I18n.t('download')}</a>
                    )}
                    <Dropzone
                      onDrop={(accepted) => {
                        this.setState({uploading: true})
                        createMedium(accepted, true)
                        change('logo_asset_id', null)
                      }}
                      style={{}}
                      activeClassName="valid"
                      className="dropZone area"
                      children={
                        <Button
                          primary
                          size="tiny"
                          icon="upload"
                          content={I18n.t('admin.mediaBrowser.upload')}
                        />
                      }
                    />
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <Divider hidden />
          </Grid.Column>

          <Grid.Column
            mobile={12}
            tablet={12}
            computer={12}
            largeScreen={4}
            widescreen={4}>
            {!isWinDeltaDealer && (
              <div>
                <Header
                  as="h3"
                  dividing
                  children={I18n.t(i18nkey + 'core.name')}
                />
                <Field
                  component={FormInput}
                  readOnly={isWinDeltaDealer}
                  fluid
                  name="name"
                />
              </div>
            )}

            <Header
              as="h3"
              dividing
              content={I18n.t(
                i18nkey +
                  (isWinDeltaDealer
                    ? 'core.title_address_wd'
                    : 'core.title_address')
              )}
            />

            <Form.Group grouped>
              <Field
                name="address1"
                component={FormInput}
                readOnly={isWinDeltaDealer}
                label={I18n.t(i18nkey + 'core.address1')}
                fluid
              />
              <Field
                name="address2"
                component={FormInput}
                readOnly={isWinDeltaDealer}
                fluid
              />
              <Field
                name="address3"
                component={FormInput}
                readOnly={isWinDeltaDealer}
                fluid
              />
              <Field
                name="address4"
                component={FormInput}
                readOnly={isWinDeltaDealer}
                fluid
              />
              <Field
                name="address5"
                component={FormInput}
                readOnly={isWinDeltaDealer}
                fluid
              />
              <Field
                name="address6"
                component={FormInput}
                readOnly={isWinDeltaDealer}
                fluid
              />
            </Form.Group>

            <Form.Group>
              <Field
                name="postcode"
                component={FormInput}
                readOnly={isWinDeltaDealer}
                label={I18n.t(i18nkey + 'core.postcode')}
                width="4"
                fluid
              />
              <Field
                name="place"
                component={FormInput}
                readOnly={isWinDeltaDealer}
                label={I18n.t(i18nkey + 'core.place')}
                width="8"
                fluid
              />
            </Form.Group>

            <Divider hidden className="compact" />
          </Grid.Column>

          <Grid.Column
            mobile={12}
            tablet={12}
            computer={12}
            largeScreen={4}
            widescreen={4}>
            <Header
              as="h3"
              dividing
              content={I18n.t(i18nkey + 'core.title_discounts')}
            />
            <Form.Group widths="equal">
              <Field
                name="discount1"
                component={FormInput}
                readOnly={isWinDeltaDealer}
                label={I18n.t(i18nkey + 'core.discount1')}
                fluid
              />
              <Field
                name="discount2"
                component={FormInput}
                readOnly={isWinDeltaDealer}
                label={I18n.t(i18nkey + 'core.discount2')}
                fluid
              />
              <Field
                name="discount3"
                component={FormInput}
                readOnly={isWinDeltaDealer}
                label={I18n.t(i18nkey + 'core.discount3')}
                fluid
              />
              <Field
                name="kind"
                component={FormInput}
                readOnly={isWinDeltaDealer}
                label={I18n.t(i18nkey + 'core.kind')}
                fluid
              />
            </Form.Group>

            <Form.Group widths="equal">
              <Field
                component={FormInput}
                readOnly
                fluid
                name="payment_terms"
                label={I18n.t(i18nkey + 'core.payment_terms')}
              />
            </Form.Group>

            {isWinDeltaDealer && (
              <Field
                component={FormCheckbox}
                label={I18n.t(i18nkey + 'status.prepayment_only')}
                name="prepayment"
                readOnly
              />
            )}
            <Divider hidden />
            <Form.Group widths="equal">
              <Field
                component={FormInput}
                readOnly
                fluid
                name="kind"
                label={I18n.t(i18nkey + 'core.kind')}
              />
              <Field
                component={FormInput}
                readOnly
                fluid
                name="address_type"
                label={I18n.t(i18nkey + 'core.address_type')}
              />
            </Form.Group>
          </Grid.Column>

          <Grid.Column
            mobile={12}
            tablet={12}
            computer={12}
            largeScreen={4}
            widescreen={4}>
            <Header dividing as="h3" content="Benutzer" />
            <Field
              name="email"
              component={FormInput}
              validate={[validateEmail, validateRequired]}
              readOnly={isWinDeltaDealer}
              label={I18n.t(i18nkey + 'core.email')}
              fluid
              required
            />
            <Field
              component={FormDropdown}
              options={config.languages}
              label="Sprache"
              placeholder={I18n.t('global.select')}
              name="language"
              selection
            />
            {user.id && (
              <Header
                dividing
                as="h3"
                content={I18n.t('login.password.change')}
              />
            )}
            {user.id && <UserChangePassword userId={user.id} />}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

UserCoreData = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserCoreData)
UserCoreData = formValues(
  'singleDropzoneUpload',
  'createdMedia',
  'media',
  'logo_asset_id',
  'address_number'
)(UserCoreData)
export default UserCoreData



// WEBPACK FOOTER //
// ./src/components/admin/Users/UserCoreData.jsx